import { Component } from '@angular/core';

@Component({
	selector: 'app-context-change',
	templateUrl: './context-change.component.html',
	styleUrls: ['./context-change.component.scss'],
	standalone: false,
})
export class ContextChangeComponent {}
